import { initI18n } from '@betstarters/i18n'

// App-specific translations
import enAuth from './locales/en/auth.json'
import enUsers from './locales/en/users.json'
import enTenants from './locales/en/tenants.json'
import enRoles from './locales/en/roles.json'
import enAudit from './locales/en/audit.json'
import enCommon from './locales/en/common.json'

import itAuth from './locales/it/auth.json'
import itUsers from './locales/it/users.json'
import itTenants from './locales/it/tenants.json'
import itRoles from './locales/it/roles.json'
import itAudit from './locales/it/audit.json'
import itCommon from './locales/it/common.json'

import esAuth from './locales/es/auth.json'
import esUsers from './locales/es/users.json'
import esTenants from './locales/es/tenants.json'
import esRoles from './locales/es/roles.json'
import esAudit from './locales/es/audit.json'
import esCommon from './locales/es/common.json'

import ptAuth from './locales/pt/auth.json'
import ptUsers from './locales/pt/users.json'
import ptTenants from './locales/pt/tenants.json'
import ptRoles from './locales/pt/roles.json'
import ptAudit from './locales/pt/audit.json'
import ptCommon from './locales/pt/common.json'

export default initI18n({
  appResources: {
    en: { common: enCommon, auth: enAuth, users: enUsers, tenants: enTenants, roles: enRoles, audit: enAudit },
    it: { common: itCommon, auth: itAuth, users: itUsers, tenants: itTenants, roles: itRoles, audit: itAudit },
    es: { common: esCommon, auth: esAuth, users: esUsers, tenants: esTenants, roles: esRoles, audit: esAudit },
    pt: { common: ptCommon, auth: ptAuth, users: ptUsers, tenants: ptTenants, roles: ptRoles, audit: ptAudit },
  },
})
